import React, { useState } from "react";
import { useAppDispatch } from "../../../hooks";
import {
  setStoredEmail,
  setVerifyType,
} from "../../../states/slices/globalReducer";
import { forgotPassword } from "../../../Services/auth";
import toast from "react-hot-toast";
import LinkHead from "../../../shared/components/LinkHead";
import AuthLayout from "../../../shared/Layouts/AuthLayout";
import { motion } from "framer-motion";
import { ENVELOPE, GO_BACK } from "../../../assets";
import ButtonV2 from "../../../shared/components/buttonV2";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const handleSendEmail = async () => {
    setLoading(true);
    dispatch(setVerifyType("PASSWORD_RESET"));

    try {
      const response = await forgotPassword({
        email,
      });
      if (response) {
        toast.success(response?.data?.message || "Email sent successfully");
        setEmail("");
        dispatch(setStoredEmail(email));
        window.history.replaceState({}, "", "/verify-otp");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <LinkHead title="Email verification" content="" />

      <AuthLayout>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="lg:w-[30rem] w-full flex flex-col gap-y-4 bg-white shadow-blur rounded-xl p-10"
        >
          <button
            onClick={() => window.history.back()}
            className="flex transition-all hover:scale-95 duration-200 items-center rounded-lg justify-center gap-x-2 border border-borderColor w-[103px] h-[40px] shadow-box"
          >
            <img src={GO_BACK} className="w-[20px] h-[20px]" alt="" />
            <span className="text-[16px] font-medium text-primary-300">
              Back
            </span>
          </button>

          <span className="text-2xl font-semibold text-black">
            Forgot Password
          </span>
          <span className="text-primary-50 font-normal text-sm">
            Kindly enter the email you used to create your account to reset your
            password. A code will be sent to that email.
          </span>

          <div className="flex flex-col items-start w-full gap-y-1">
            <span className="text-sm font-medium text-[#4F5762]">
              Email Address
            </span>
            <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
              <img src={ENVELOPE} className="w-[20px] h-[20px]" alt="" />
              <input
                type="text"
                placeholder="Email"
                name="email"
                value={email}
                onChange={(e) => {
                  const nospaced = e.target.value.replace(/\s/g, "");
                  setEmail(nospaced);
                }}
                className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
              />
            </div>
          </div>

          <ButtonV2
            btnStyle="w-full bg-globalGold h-[48px] flex items-center justify-center rounded-xl mt-4"
            textStyle="text-white font-semibold text-[16px]"
            title="Reset Password"
            loaderColor="#ffffff"
            disabled={!email || loading}
            handleClick={handleSendEmail}
            loading={loading}
          />
        </motion.div>
      </AuthLayout>
    </>
  );
}

export default ForgotPassword;
